<template>
  <table class="table table-bordered table-responsive table-hover table-sm">
    <thead>
    <tr>
      <th v-for="col in cols">{{ col }}</th>
    </tr>
    </thead>
    <tbody>
    <tr v-for="row in rows">
      <td v-for="(v, k) in cols">{{ row[k] }}</td>
    </tr>
    </tbody>
  </table>
</template>

<script>
  export default {
    name: 'table-edit',
    props: {
      'cols': {
        type: Object, required: true
      },
      'rows': {
        type: Array, required: true
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/ui/table-edit.vue